import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersPromocodesFreeParams, GetVouchersPromocodesFreeResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersPromocodesFree = createAsyncThunk<
  GetVouchersPromocodesFreeResponse,
  GetVouchersPromocodesFreeParams
>(
  `vouchers/getVouchersPromocodesFree`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersPromocodesFree({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers promocodes free",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers promocodes free", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);